import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { ErrorBoundaryFallback } from 'components/error-boundary/fallback';
import { ComponentType, FC, PropsWithChildren } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

interface SchedulerErrorBoundaryProps {
    resetKeys?: string[];
    fallbackComponent?: ComponentType<FallbackProps>;
}

const SchedulerErrorBoundary: FC<PropsWithChildren & SchedulerErrorBoundaryProps> = ({
    children,
    resetKeys,
    fallbackComponent = ErrorBoundaryFallback,
}) => {
    const { reset } = useQueryErrorResetBoundary();

    return (
        <ErrorBoundary FallbackComponent={fallbackComponent} onReset={reset} resetKeys={resetKeys}>
            {children}
        </ErrorBoundary>
    );
};

export { SchedulerErrorBoundary };
